export const CASH_BOX_ACCOUNT_TYPE = "קופה" as const;
export const CASH_BOXES_PATH = "/cash-boxes";
export const CASH_BOXES_BREADCRUMB = { ledger: "כרטסות", list: "קופות" } as const;
export const CASH_BOXES_STRUCTURE_CRUMBS = {
  search: "הגדרת מבנה חיפוש",
  browse: "הגדרת מבנה דפדוף",
} as const;
export const SEARCH_TABLE_STYLE = {
  backgroundColor: "rgb(35, 48, 68)",
  padding: 5,
  marginButton: 20,
} as const;
